import { LANGUAGE, OrgCurrency, PlanId } from "../../utils/shared/constants";
import { CardLayout } from "./CardLayout";
import { DealStep } from "./DealStep";
import { OfferBlock } from "./Offer";
import { Place } from "./Place";
import { TagDefinition } from "./TagDefinition";

export interface OrgSettings {
    currency?: OrgCurrency;
    paymentInstructions?: string;
    language?: LANGUAGE;
    customerFormIntroText?: string;
    customerFormThankYouText?: string;
}

export interface Organization {
    id?: string,
    createdAt: Date,
    ownedBy: string,
    dealSteps: DealStep[],
    settings?: OrgSettings,

    cardLayout?: CardLayout,
    tags?: TagDefinition[],

    place?: Place
    type?: OrganizationType

    name?: string
    email?: string
    website?: string
    logo?: string
    defaultOfferBlocks?: OfferBlock[],

    features?: {
        hoursTracking?: boolean;
        riskAssessment?: boolean;
    }
    integrations?: {
        accountingType?: IntegrationType;
    }

    billing?: OrganizationBilling
    trialEndsAt?: Date | null;
    env?: OrganizationEnv;

    // When each one-time funnel milestone was first reached (set by the backend)
    milestones?: Partial<Record<OrgMilestone, Date>>;
}

export type OrgMilestone = 'first_deal_created' | 'first_offer_accepted' | 'first_paid_plan';

export type IntegrationType = 'fortnox';

export type OrganizationEnv = 'test' | 'live';

export interface OrganizationBilling {
    planId: PlanId;
    stripeCustomerId: string;
    stripeSubscriptionId: string;
}

export enum OrganizationType {
    cgh = 'cgh',
    arbTask = 'arbTask',
}


export interface OrganizationPublic {
    name?: string
    email?: string
    website?: string
    logo?: string
    place?: Place
    dealSteps: DealStep[],
    tags?: TagDefinition[]
    settings?: OrgSettings
}
